import React, { useState } from 'react';
import Header from './components/Header';
import CompanySecondary from './components/CompanySecondary';
import ZoneWiseSecondaryClosing from './components/ZoneWiseSecondaryClosing';
import DivisionSecondary from './components/DivisionSecondary';
import DivisionSecondaryBrush from './components/DivisionSecondaryBrush';
import TopSKUs from './components/TopSKUs';
import AvgInventoryDays from './components/AvgInventoryDays';
import { getDefaultPeriod, MonthYearValue } from './components/MonthYearFilter';
import { ViewMode } from './components/ViewModeToggle';

const Dashboard: React.FC = () => {
  const [period, setPeriod] = useState<MonthYearValue>(getDefaultPeriod());
  const [viewMode, setViewMode] = useState<ViewMode>('value');

  return (
    <>
      <Header
        period={period}
        onPeriodChange={setPeriod}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />
      <div className="row g-6 mb-6">
        <CompanySecondary period={period} viewMode={viewMode} />
        <AvgInventoryDays period={period} viewMode={viewMode} />
      </div>
      <div className="row g-6 mb-6">
        <ZoneWiseSecondaryClosing period={period} viewMode={viewMode} />
        <TopSKUs period={period} viewMode={viewMode} />
      </div>
      {/* <div className="row g-6 mb-6">
        <DivisionSecondary period={period} viewMode={viewMode} />
      </div> */}
      <div className="row g-6 mb-6">
        <DivisionSecondaryBrush period={period} viewMode={viewMode} />
      </div>
    </>
  );
};

export default Dashboard;
